import { useEffect, useState } from 'react'
import { getServicesPage } from 'services/pageService'
import { ServicesPageProps } from 'types/servicesPage'

export default function useServicesPage() {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState<ServicesPageProps | null>(null)

  const fetchData = async () => {
    const items = await getServicesPage()

    setData(items as ServicesPageProps)
    setLoading(false)
  }

  useEffect(() => {
    fetchData()
  }, [])

  return { data, loading }
}
